import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonashikinnovacrysta() {



const cardData = {
keyword: "Pune Darshan Innova Crysta Cabs",
headingDescription: "Pune Darshan Innova Crysta Cabs provide comfortable private transportation for families, tourists, senior citizens, friends, and groups exploring Pune's temples, historical landmarks, cultural attractions, and popular sightseeing locations. With spacious seating, air conditioning, luggage space, and a dedicated driver, the Innova Crysta is suitable for Pune city tours, temple visits, one-day sightseeing plans, family outings, and customized local travel itineraries.",
topPlaces: [
{
title: "Shaniwar Wada",
description: "Shaniwar Wada is one of Pune's most recognized historical landmarks and an important stop for visitors interested in Maratha history and architecture. A private Innova Crysta makes it convenient for families and groups to include this heritage destination in a planned Pune Darshan itinerary."
},
{
title: "Aga Khan Palace",
description: "Aga Khan Palace is a significant historical attraction in Pune, known for its architecture, gardens, and connection with India's freedom movement. Travelers can comfortably visit the palace as part of a city sightseeing tour using a spacious Innova Crysta with a dedicated driver."
},
{
title: "Dagdusheth Halwai Ganpati Temple",
description: "Dagdusheth Halwai Ganpati Temple is a prominent religious destination in Pune and a popular stop during local temple tours. Families and groups can use a private Innova Crysta to conveniently include the temple along with other nearby sightseeing attractions."
},
{
title: "Sinhagad Fort",
description: "Sinhagad Fort is a popular historical and hill destination near Pune, offering scenic surroundings along with significant historical importance. An Innova Crysta is suitable for families and groups planning a comfortable sightseeing journey to the fort and nearby attractions."
},
{
title: "Pataleshwar Cave Temple",
description: "Pataleshwar Cave Temple is an ancient rock-cut temple located in the heart of Pune and is frequently included in city sightseeing itineraries. Private cab transportation allows visitors to combine the temple with other heritage and cultural attractions during their Pune Darshan."
},
{
title: "Parvati Hill",
description: "Parvati Hill is a popular Pune landmark offering panoramic views of the surrounding city along with historic temples. Families and tourists can include the location in a customized Pune sightseeing route while traveling comfortably in a spacious Innova Crysta."
},
{
title: "Raja Dinkar Kelkar Museum",
description: "Raja Dinkar Kelkar Museum houses an extensive collection of traditional Indian artifacts and is a useful stop for travelers interested in art, culture, and history. A private Innova Crysta provides convenient transportation for groups visiting the museum as part of Pune Darshan."
},
{
title: "Pune Okayama Friendship Garden",
description: "Pune Okayama Friendship Garden is a landscaped attraction suitable for relaxed sightseeing, photography, and family outings. Travelers can include the garden in a one-day Pune city tour along with temples, historical sites, and other popular local destinations."
},
{
title: "Empress Garden",
description: "Empress Garden is a well-known green space in Pune and can be included in a relaxed local sightseeing itinerary. Families and groups can travel between the garden and other city attractions in one spacious Innova Crysta for a convenient day-long tour."
},
{
title: "Peshwa Udyan",
description: "Peshwa Udyan is a family-oriented recreational destination that can be included in a Pune local sightseeing plan. A private Innova Crysta provides comfortable transportation for families and groups looking to cover multiple Pune attractions during the same outing."
}
],
services: [
{
name: "Pune Darshan Innova Crysta Cab",
description: "Pune Darshan Innova Crysta Cab provides private transportation for travelers exploring Pune's temples, historical landmarks, gardens, museums, and tourist attractions. The spacious vehicle is suitable for families and groups planning a comfortable full-day city tour."
},
{
name: "Pune Darshan Innova Crysta Taxi",
description: "Pune Darshan Innova Crysta Taxi offers convenient local transportation for tourists and residents planning Pune sightseeing. With spacious seating and a dedicated driver, the vehicle can be used to visit multiple attractions according to a customized itinerary."
},
{
name: "Pune Darshan Innova Crysta Booking",
description: "Pune Darshan Innova Crysta Booking allows travelers to arrange a spacious private vehicle before their planned sightseeing day. Advance booking is useful for families, groups, senior travelers, temple tours, and visitors who want their local transportation organized in advance."
},
{
name: "Pune City Tour Innova Crysta Cab",
description: "Pune City Tour Innova Crysta Cab provides comfortable transportation for visitors exploring important attractions across Pune. The spacious cabin is suitable for multi-stop city tours covering historical places, temples, museums, gardens, and cultural destinations."
},
{
name: "Pune Local Sightseeing Innova Crysta",
description: "Pune Local Sightseeing Innova Crysta is suitable for families and groups planning a customized local sightseeing itinerary. Passengers can comfortably travel between different Pune attractions while keeping their belongings and sightseeing essentials in the vehicle."
},
{
name: "Pune Sightseeing Innova Crysta Taxi",
description: "Pune Sightseeing Innova Crysta Taxi provides private transportation for travelers visiting Pune's popular tourist attractions. The seven-seater vehicle is useful for families, friends, and small groups who want to explore multiple locations during a single outing."
},
{
name: "Pune Darshan AC Innova Crysta",
description: "Pune Darshan AC Innova Crysta offers air-conditioned private transportation for passengers exploring Pune during a sightseeing trip. The comfortable cabin is suitable for families, senior citizens, tourists, and groups spending several hours traveling between attractions."
},
{
name: "Pune Darshan Luxury Innova Crysta",
description: "Pune Darshan Luxury Innova Crysta provides a premium private travel option for passengers who prefer additional comfort during their city tour. Spacious seating and an air-conditioned cabin make it suitable for family outings, special occasions, and tourist visits."
},
{
name: "Pune Darshan 7 Seater Innova Crysta",
description: "Pune Darshan 7 Seater Innova Crysta is practical for families and small groups who want to explore Pune together. The seven-seater configuration provides useful passenger space while allowing the group to travel between several sightseeing locations in one vehicle."
},
{
name: "Pune Temple Tour Innova Crysta Pune",
description: "Pune Temple Tour Innova Crysta Pune provides private transportation for travelers visiting multiple temples across the city. Families, devotees, and senior citizens can plan a convenient temple-focused itinerary with comfortable seating and a dedicated vehicle."
},
{
name: "Pune One Day Tour Innova Crysta",
description: "Pune One Day Tour Innova Crysta is suitable for travelers planning a complete sightseeing day across Pune. The spacious vehicle allows families and groups to cover multiple attractions while keeping the itinerary organized around their preferred schedule."
},
{
name: "Pune Local Tour Innova Crysta Rental",
description: "Pune Local Tour Innova Crysta Rental provides a spacious private vehicle for customized city tours and local travel. It can be useful for family outings, sightseeing, temple visits, historical tours, and group travel across Pune."
},
{
name: "Pune Historical Tour Innova Crysta",
description: "Pune Historical Tour Innova Crysta is suitable for visitors interested in exploring the city's forts, palaces, museums, temples, and heritage landmarks. A private vehicle makes it easier to combine multiple historical attractions within one sightseeing itinerary."
},
{
name: "Pune Tourist Places Innova Crysta Cab",
description: "Pune Tourist Places Innova Crysta Cab provides convenient transportation for visitors exploring popular tourist destinations across Pune. The spacious vehicle is suitable for families and groups who want to travel comfortably between multiple attractions during their city tour."
},
{
name: "Pune Family Sightseeing Innova Crysta",
description: "Pune Family Sightseeing Innova Crysta offers comfortable private transportation for families visiting Pune's temples, historical sites, gardens, museums, and recreational attractions. The spacious cabin provides useful room for family members and their belongings."
},
{
name: "Pune Group Sightseeing Innova Crysta",
description: "Pune Group Sightseeing Innova Crysta is designed for friends, relatives, colleagues, and small groups planning to explore Pune together. Traveling in one spacious vehicle makes it easier to coordinate pickups, sightseeing stops, and the overall local itinerary."
},
{
name: "Affordable Pune Darshan Innova Crysta",
description: "Affordable Pune Darshan Innova Crysta is a suitable search option for travelers comparing private vehicles for Pune sightseeing. The overall travel cost can depend on the duration, number of destinations, pickup location, and customized itinerary selected by the passengers."
},
{
name: "Pune Darshan Cab on Rent",
description: "Pune Darshan Cab on Rent provides a convenient vehicle option for travelers planning local sightseeing around Pune. It can be used for temple tours, family outings, historical sightseeing, tourist visits, and customized one-day travel plans."
},
{
name: "Pune Darshan Taxi Hire",
description: "Pune Darshan Taxi Hire allows travelers to arrange private transportation for a planned Pune sightseeing itinerary. Families and groups can use a spacious vehicle to visit several destinations while enjoying convenient point-to-point travel."
},
{
name: "Pune Darshan Cab Near Me",
description: "Pune Darshan Cab Near Me is useful for travelers searching for a convenient local sightseeing vehicle around Pune. Passengers can consider vehicle size, pickup requirements, travel duration, and planned destinations when arranging their Pune Darshan trip."
},
{
name: "Pune City Sightseeing Cab with Driver",
description: "Pune City Sightseeing Cab with Driver provides private transportation with a dedicated driver for exploring multiple city attractions. This arrangement is useful for tourists, families, and groups who prefer focusing on sightseeing instead of managing city driving themselves."
},
{
name: "Pune Local Innova Crysta Rental",
description: "Pune Local Innova Crysta Rental provides a spacious vehicle for local travel requirements across Pune. It can support sightseeing tours, temple visits, family outings, corporate visits, and customized travel schedules requiring comfortable transportation."
},
{
name: "Pune Darshan Private Cab",
description: "Pune Darshan Private Cab offers exclusive transportation for passengers who prefer to travel with their own family or group. The private arrangement is suitable for customized sightseeing routes covering temples, historical landmarks, museums, and tourist attractions."
},
{
name: "Pune One Day Sightseeing Taxi Pune",
description: "Pune One Day Sightseeing Taxi Pune provides private transportation for passengers planning a complete day of local sightseeing. Families and groups can arrange multiple stops according to their preferred itinerary and spend the day exploring Pune comfortably."
},
{
name: "Pune Tourist Cab Innova Crysta",
description: "Pune Tourist Cab Innova Crysta provides spacious private transportation for visitors exploring Pune's tourist destinations. It is suitable for family tours, group sightseeing, temple visits, historical trips, and one-day city exploration."
}
],
tableData: [
["Pune Darshan Innova Crysta Cab"],
["Pune Darshan Innova Crysta Taxi"],
["Pune Darshan Innova Crysta Booking"],
["Pune City Tour Innova Crysta Cab"],
["Pune Local Sightseeing Innova Crysta"],
["Pune Sightseeing Innova Crysta Taxi"],
["Pune Darshan AC Innova Crysta"],
["Pune Darshan Luxury Innova Crysta"],
["Pune Darshan 7 Seater Innova Crysta"],
["Pune Temple Tour Innova Crysta Pune"],
["Pune One Day Tour Innova Crysta"],
["Pune Local Tour Innova Crysta Rental"],
["Pune Historical Tour Innova Crysta"],
["Pune Tourist Places Innova Crysta Cab"],
["Pune Family Sightseeing Innova Crysta"],
["Pune Group Sightseeing Innova Crysta"],
["Affordable Pune Darshan Innova Crysta"],
["Pune Darshan Cab on Rent"],
["Pune Darshan Taxi Hire"],
["Pune Darshan Cab Near Me"],
["Pune City Sightseeing Cab with Driver"],
["Pune Local Innova Crysta Rental"],
["Pune Darshan Private Cab"],
["Pune One Day Sightseeing Taxi Pune"],
["Pune Tourist Cab Innova Crysta"]
],
whychoose: [
{
WhyChooseheading: "Spacious Vehicle for Pune Sightseeing",
WhyChoosedescription: "The Innova Crysta offers generous seating and practical luggage space, making it suitable for families and groups visiting several Pune attractions in one day. Everyone can travel together in the same private vehicle."
},
{
WhyChooseheading: "Convenient Multi-Stop Travel",
WhyChoosedescription: "A private sightseeing cab makes it easier to organize multiple attractions within one itinerary. Travelers can plan visits to temples, historical landmarks, museums, gardens, and other destinations according to their preferred schedule."
},
{
WhyChooseheading: "Comfortable AC Interior",
WhyChoosedescription: "The air-conditioned cabin provides a comfortable environment during a full day of local sightseeing. Spacious seating is particularly useful for families, senior citizens, tourists, and groups spending several hours on the road."
},
{
WhyChooseheading: "Ideal for Family Outings",
WhyChoosedescription: "Families can travel together in a seven-seater Innova Crysta while keeping personal belongings and sightseeing essentials conveniently accommodated. The private vehicle is suitable for both relaxed outings and packed sightseeing schedules."
},
{
WhyChooseheading: "Suitable for Temple Tours",
WhyChoosedescription: "Travelers planning visits to multiple temples can organize a dedicated temple-tour itinerary using one private cab. This makes it convenient to coordinate transportation between religious destinations and other nearby attractions."
},
{
WhyChooseheading: "Useful for Historical Tours",
WhyChoosedescription: "Pune has several forts, heritage landmarks, museums, and historically important locations. A private Innova Crysta allows visitors to combine multiple heritage destinations within a customized sightseeing route."
},
{
WhyChooseheading: "Private Cab With Driver",
WhyChoosedescription: "With a dedicated driver, passengers can focus on their sightseeing plans instead of managing city traffic and parking. This is convenient for visitors unfamiliar with Pune and for groups traveling with children or senior family members."
},
{
WhyChooseheading: "Flexible One-Day Itineraries",
WhyChoosedescription: "A one-day Pune Darshan plan can be organized around the destinations and timing preferred by the travelers. The Innova Crysta provides the space and convenience needed for families and groups covering several local attractions."
}
]
};











const faqData = [
{
question: "Can I book an Innova Crysta for Pune Darshan?",
answer: "An Innova Crysta can be arranged for a Pune Darshan tour when families, friends, senior citizens, or small groups want to visit multiple attractions together. Share your preferred pickup location, travel date, passenger count, and sightseeing requirements so the itinerary can be planned around your schedule."
},
{
question: "Why choose an Innova Crysta for Pune Darshan?",
answer: "An Innova Crysta can be a convenient option for groups visiting several places across Pune in one day. Travelling together in a dedicated vehicle makes it easier to coordinate the sightseeing route, manage luggage or personal belongings, and accommodate family members during a full-day city tour."
},
{
question: "Which places can be covered with Pune Darshan Innova Crysta Cabs?",
answer: "A Pune Darshan itinerary can include attractions such as Shaniwar Wada, Aga Khan Palace, Sinhagad Fort, Pataleshwar Cave Temple, Dagdusheth Halwai Ganpati Temple, Saras Baug, and other locations based on the group's interests and available time."
},
{
question: "Can families hire an Innova Crysta for Pune sightseeing?",
answer: "Families can use an Innova Crysta for a Pune sightseeing tour when several members want to explore the city together. The itinerary can be arranged around the group's preferred attractions, meal breaks, sightseeing duration, and pickup or drop location."
},
{
question: "Can senior citizens travel in an Innova Crysta for Pune Darshan?",
answer: "Families travelling with senior citizens can consider an Innova Crysta for Pune Darshan because a dedicated vehicle allows the sightseeing schedule to be organized according to the group's pace. Suitable breaks and shorter travel intervals between selected attractions can also be included in the itinerary."
},
{
question: "Can I book a full-day Innova Crysta for Pune Darshan?",
answer: "A full-day Innova Crysta booking can be planned for travellers who want to cover multiple Pune attractions without arranging separate transportation for every stop. The sightseeing route, starting point, preferred visiting hours, and expected duration can be discussed while arranging the cab."
},
{
question: "Can I customize my Pune Darshan itinerary with an Innova Crysta?",
answer: "Passengers can discuss their preferred sightseeing locations before the trip and create an itinerary based on the available time. Religious places, historical attractions, gardens, museums, forts, and other Pune destinations can be considered according to the group's interests and planned route."
},
{
question: "Is Innova Crysta suitable for group sightseeing in Pune?",
answer: "Small groups can choose an Innova Crysta when they want to explore Pune together in one vehicle. This arrangement can simplify coordination between sightseeing points and provide a dedicated transportation option for families, friends, or visiting relatives."
},
{
question: "Can I book Pune Darshan Innova Crysta for guests visiting Pune?",
answer: "An Innova Crysta can be arranged for guests, relatives, or business visitors who want to explore Pune during their stay. The sightseeing plan can include selected attractions along with hotel pickup, restaurant stops, or other destinations required during the city tour."
},
{
question: "How can I book Pune Darshan Innova Crysta Cabs with Citysky Cabs?",
answer: "To arrange an Innova Crysta for Pune Darshan, provide your pickup location, travel date, passenger count, preferred sightseeing places, starting time, and approximate tour duration. Citysky Cabs can coordinate the vehicle according to your planned Pune sightseeing itinerary."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Mahendra Joshi",
feedback:
"My relatives were visiting Pune for the first time, so I arranged an Innova Crysta for a full-day Pune Darshan. We wanted to cover historical and religious places without managing different vehicles. Citysky Cabs helped us organize the cab around the sightseeing route, which made the day easier for everyone.",
rating: 5
},
{
id: 2,
name: "Miss. Rutuja Desai",
feedback:
"I planned a Pune sightseeing day for my parents and a few relatives and preferred one spacious cab for the group. The Innova Crysta was convenient for moving between different attractions, and we could follow our planned stops without worrying about separate transportation arrangements. The booking with Citysky Cabs was smooth.",
rating: 5
}
];





















    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Darshan Innova Crysta Cabs",
  "image": "https://www.cityskycab.in/assets/images/pune-darshan-innova-crysta-cabs.webp",
  "description": "Pune Darshan Innova Crysta Cabs from Citysky Cabs are designed for comfortable city sightseeing, family outings and private Pune tours with a spacious premium vehicle. The service includes Pune Darshan Innova Crysta Cab, Pune Darshan Innova Crysta Taxi and Pune City Tour Innova Crysta Cab options for travellers who want to explore multiple attractions conveniently in one vehicle. With air conditioning, comfortable seating and experienced local drivers, the Innova Crysta is suitable for families, friends, senior travellers and small groups. Pune Local Sightseeing can be planned around the preferred pickup location, visiting schedule and duration, making it easier to cover popular city attractions without depending on multiple local transport options.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/pune-darshan-innova-crysta-cabs"
  }
};





    return (
        <div>

<Helmet>
  <title>
    Pune Darshan Innova Crysta Cabs | Pune City Tour Innova Crysta Cab | +91 8554819191
  </title>

  <meta
    name="description"
    content="Explore Pune comfortably with a private Innova Crysta cab from Citysky Cabs. Ideal for Pune Darshan, city tours and local sightseeing with AC comfort, spacious seating and experienced drivers."
  />

  <meta
    name="keywords"
    content="Pune Darshan Innova Crysta Cab, Pune Darshan Innova Crysta Taxi, Pune Darshan Innova Crysta Booking, Pune City Tour Innova Crysta Cab, Pune Local Sightseeing, Pune Darshan Innova Crysta Cabs, Pune sightseeing cab, Pune city tour taxi, Pune local sightseeing cab, Innova Crysta for Pune Darshan, Pune sightseeing Innova Crysta, Pune local tour cab, Pune city sightseeing taxi, Pune Darshan AC cab, Pune full day Innova Crysta cab, Pune tourist places cab service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/17.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetonashikinnovacrysta;